import { Injectable } from '@angular/core';
import { Action, Store, select } from '@ngrx/store';

import { Session } from '@lockton-apps/shared/interfaces';

import * as AuthActions from './auth.actions';
import * as AuthSelectors from './auth.selectors';

@Injectable()
export class SharedAuthFacade {
  isLoading$ = this.store.pipe(select(AuthSelectors.getIsLoading));
  isAuthenticated$ = this.store.pipe(select(AuthSelectors.getIsAuthenticated));
  requiresMfa$ = this.store.pipe(select(AuthSelectors.getRequiresMfa));
  username$ = this.store.pipe(select(AuthSelectors.getUsername));
  nameId$ = this.store.pipe(select(AuthSelectors.getNameId));
  givenName$ = this.store.pipe(select(AuthSelectors.getGivenName));
  familyName$ = this.store.pipe(select(AuthSelectors.getFamilyName));
  emails$ = this.store.pipe(select(AuthSelectors.getEmails));
  role$ = this.store.pipe(select(AuthSelectors.getRole));
  roleAndIsPrimaryContact$ = this.store.pipe(
    select(AuthSelectors.getRoleAndIsPrimaryContact)
  );

  constructor(private readonly store: Store) {}

  init() {
    this._dispatch(AuthActions.init());
  }

  refreshToken(): void {
    this._dispatch(AuthActions.refreshToken());
  }

  authenticateFromSession(session: Session) {
    this._dispatch(AuthActions.authenticateSession({ session }));
  }

  timeoutWarning(): void {
    this._dispatch(AuthActions.timeoutWarning());
  }

  logout(): void {
    this._dispatch(AuthActions.logout());
  }

  private _dispatch(action: Action): void {
    this.store.dispatch(action);
  }
}
